// extracted by mini-css-extract-plugin
module.exports = {"container":"f_c","text":"f_l","background":"f_m"};